import React from 'react';
import { CounterRowData } from '../../../../interfaces/counterSection.types';

import {
  Circle,
  Circumference,
  Container,
  CounterIcon,
  CounterRow,
  Description,
  IconWithValuesContainer,
  TwoCircles,
  Value,
  ValueDescriptionContainer,
} from './counter.styled';
import { CounterData } from './counter.types';

export const Counter: React.FC<CounterData> = (data: CounterData) => {
  const { counterData } = data;

  const renderRows = () => counterData.counterRow.map((row: CounterRowData) => (
    <CounterRow>
      <IconWithValuesContainer>
        <CounterIcon
          src={row.rowIcon}
          alt=''
        />
        <ValueDescriptionContainer>
          <Value>{row.value} {row.unit}</Value>
          <Description>{row.description}</Description>
        </ValueDescriptionContainer>
      </IconWithValuesContainer>
      <TwoCircles>
        <Circle />
        <Circumference />
      </TwoCircles>
    </CounterRow>
  ));

  return (
    <Container className='counter-section'>
      {renderRows()}
    </Container>
  );
}
